import moment from 'moment';

const resolveDisabledDatesOptions = (jsonOptions) => {
  let options = {};

  if (jsonOptions.disabledDates) {
    options.disabledDates = {};
    if (jsonOptions.disabledDates.to) {
      options.disabledDates.to = configToDate(jsonOptions.disabledDates.to);
    }

    if (jsonOptions.disabledDates.from) {
      options.disabledDates.from = configToDate(jsonOptions.disabledDates.from);
    }
  }

  return {
    ...jsonOptions,
    ...options
  };
};

const resolveInDateRageOptions = (jsonOptions) => {
  let options = {};

  if (jsonOptions) {
    if (jsonOptions.start) {
      options.start = configToDate(jsonOptions.start);
    }

    if (jsonOptions.end) {
      options.end = configToDate(jsonOptions.end);
    }
  }

  return {
    ...options
  };
};

const configToDate = (config) => {
  let date;
  if (config.date === "today") {
    date = moment();
  } else {
    date = moment(config.date, "MM/DD/YYYY", true);
  }

  if (config.manipulate) {
    const duration = moment.duration(config.manipulate.duration.amount, config.manipulate.duration.unit);
    date[config.manipulate.action](duration);
  }

  return date.toDate();
};

export {
  resolveDisabledDatesOptions,
  resolveInDateRageOptions
};